import React from 'react';
import { connect } from 'react-redux';

import Header from './header/header';
import Sidebar from './sidebar/sidebar';
import Content from './content/content';
import Footer from './footer/footer';

// css
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-social/bootstrap-social.css';
import 'react-quill/dist/quill.snow.css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'simple-line-icons/css/simple-line-icons.css';
import 'flag-icon-css/css/flag-icon.min.css';
import '../../assets/admin/css/index.css';

// for summer note
import 'bootstrap/dist/js/bootstrap';
import $ from 'jquery';
window.jQuery = $;
require('bootstrap');

const AdminLayout = props => {

    // css/default/style.css 223�� ����, bg color, scroll event 
    document.querySelector('body').style.background = "#d9e0e7";
    document.querySelector('body').style.height = "100%";  

    return (
        <div className={ 'fade page-sidebar-fixed show page-container ' +
            (props.header.pageHeader ? 'page-header-fixed ' : '') +

            (props.sidebar.pageSidebar ? '' : 'page-without-sidebar ') +
            (props.sidebar.pageRightSidebar ? 'page-with-right-sidebar ' : '') +
            (props.sidebar.pageSidebarWide ? 'page-with-wide-sidebar ' : '') +
            (props.sidebar.pageSidebarLight ? 'page-with-light-sidebar ' : '') +
            (props.sidebar.pageSidebarMinify ? 'page-sidebar-minified ' : '') +
            (props.sidebar.pageSidebarToggled ? 'page-sidebar-toggled ' : '') + 

            (props.header.pageTopMenu ? 'page-with-top-menu ' : '') +
            (props.content.pageContentFullHeight ? 'page-content-full-height ' : '') +

            (props.header.pageTwoSidebar ? 'page-with-two-sidebar ' : '') +
            (props.header.pageRightSidebarCollapsed ? 'page-right-sidebar-collapsed ' : '') +
            (props.header.pageMobileRightSidebarToggled ? 'page-right-sidebar-toggled ' : '')
        }>
            {props.header.pageHeader && (<Header />)}
            {props.sidebar.pageSidebar && (<Sidebar />)}
            {props.content.pageContent && (<Content children={props.children} />)}
            {props.footer.pageFooter && (<Footer />)}
        </div>
    )
}

export default connect(state => state, null)(AdminLayout);






// WEBPACK FOOTER //
// ./src/components/admin/adminLayout.js